import React, { useState } from "react";
import {
  Maybe,
  PrismicStandardLandingPageDataBodyImageGridItem,
  PrismicImageField,
  PrismicRichTextField,
} from "../../types/graphql";
import {
  EntryBase,
  Image,
  ImageWrapper,
  Title,
  Subtitle,
  Description,
  StyledModal,
  ModalCloseButton,
  ModalContents,
  ModalImage,
  ModalTitle,
  ModalText,
  ModalSubtitle,
} from "./image-grid-entry.styled";
import { PrismicRichText as PrismicRichTextReact } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import * as FA from "../../styles/fontawesome";

interface IImageGridEntryProps {
  entry: Pick<
    PrismicStandardLandingPageDataBodyImageGridItem,
    "title" | "subtitle"
  > & {
    image?: Maybe<Pick<PrismicImageField, "url" | "alt">>;
    description?: Maybe<Pick<PrismicRichTextField, "richText">>;
  };
  index: number;
}

const ImageGridEntry = (props: IImageGridEntryProps) => {
  const { entry } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEntryClick = () => {
    setIsModalOpen(true);
  };

  return (
    (entry && (
      <>
        <EntryBase
          tabIndex={0}
          onClick={handleEntryClick}
          onKeyPress={handleEntryClick}
          id={`image-grid-entry-${props.index}`}
        >
          {entry.image?.url && (
            <ImageWrapper>
              <Image
                src={entry.image.url}
                alt={entry.image.alt || "Xometry Image"}
                className="grid-image"
              />
            </ImageWrapper>
          )}
          {entry.title && <Title>{entry.title}</Title>}
          {entry.subtitle && <Subtitle>{entry.subtitle}</Subtitle>}
        </EntryBase>
        {isModalOpen && (
          <StyledModal
            isOpen={isModalOpen}
            selector={`#image-grid-entry-${props.index}`}
          >
            <ModalCloseButton
              kind="text"
              icon
              type="button"
              onClick={() => setIsModalOpen(false)}
            >
              <i css={FA.XMarkRegular} />
            </ModalCloseButton>
            <ModalContents>
              {entry.image?.url && (
                <ModalImage
                  src={entry.image.url}
                  alt={entry.image.alt || "Xometry Image"}
                />
              )}
              <ModalText>
                {entry.subtitle && (
                  <ModalSubtitle>{entry.subtitle}</ModalSubtitle>
                )}
                {entry.title && <ModalTitle>{entry.title}</ModalTitle>}
                {entry.description && (
                  <Description>
                    <PrismicRichTextReact
                      field={entry.description.richText}
                      components={htmlSerializer}
                    />
                  </Description>
                )}
              </ModalText>
            </ModalContents>
          </StyledModal>
        )}
      </>
    )) || <></>
  );
};

export default ImageGridEntry;
